import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchgetAllSettingsApi } from "../Redux/settings_Slice";
import FromikTextField from "../Components/Utils/Formik_Texfiled";
import CustomButton from "../Components/Utils/Custom_Btn";
import { UpdateSettingsApi } from "../Apis/settings/settings";
import { useToast } from "../Hooks/useToast";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Grid,
  Chip,
  Tabs,
  Tab
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  format,
  isSameMonth,
  isSameDay,
  parseISO
} from "date-fns";

const CELL_SIZE = 50;

const Einstellungen = () => {
  const role=localStorage.getItem("role")
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.data);
  const loading = useSelector((state) => state.settings.loading);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [timings, setTimings] = useState({
    summer: { open: null, close: null },
    winter: { open: null, close: null }
  });
  const [season, setSeason] = useState("summer");
  const [daysOff, setDaysOff] = useState([]);
  const { toastSuccess, toastError } = useToast();

  const formik = useFormik({
    initialValues: {
      note1: "",
      note2: "",
      note3: ""
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      note1: Yup.string(),
      note2: Yup.string(),
      note3: Yup.string()
    }),
    onSubmit: async (values) => {
      const updatedPayload = {
        ...values,
        timings: {
          summer: {
            open: timings.summer.open ? format(timings.summer.open, "HH:mm") : "",
            close: timings.summer.close ? format(timings.summer.close, "HH:mm") : ""
          },
          winter: {
            open: timings.winter.open ? format(timings.winter.open, "HH:mm") : "",
            close: timings.winter.close ? format(timings.winter.close, "HH:mm") : ""
          }
        },
        daysOff
      };
      try {
        await UpdateSettingsApi(updatedPayload);
        dispatch(fetchgetAllSettingsApi());
        toastSuccess("Die Einstellungen wurden erfolgreich aktualisiert.");
      } catch (error) {
        console.error("Update failed:", error);
        toastError("Fehler beim Aktualisieren der Einstellungen. Bitte versuchen Sie es erneut.");
      }      
    }
  });

  useEffect(() => {
    dispatch(fetchgetAllSettingsApi());
  }, [dispatch]);

  useEffect(() => {
    if (settings) {
      formik.setValues({
        note1: settings.note1 || "",
        note2: settings.note2 || "",
        note3: settings.note3 || ""
      });


      const convertTimeStringToDate = (timeStr) => {
        if (!timeStr) return null;
        const [hours, minutes] = timeStr.split(":");
        const date = new Date();
        date.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
        return date;
      };

      setTimings({
        summer: {
          open: convertTimeStringToDate(settings.timings?.summer?.open),
          close: convertTimeStringToDate(settings.timings?.summer?.close)
        },
        winter: {
          open: convertTimeStringToDate(settings.timings?.winter?.open),
          close: convertTimeStringToDate(settings.timings?.winter?.close)
        }
      });

      if (settings.daysOff) {
        setDaysOff(settings.daysOff);
      }
    }
  }, [settings]);

  const handleTimeChange = (seasonType, timeType, newValue) => {
    setTimings((prev) => ({
      ...prev,
      [seasonType]: { ...prev[seasonType], [timeType]: newValue }
    }));
  };

  const toggleDayOff = (day) => {
    const dayFormatted = format(day, "yyyy-MM-dd");
    setDaysOff((prev) =>
      prev.includes(dayFormatted)
        ? prev.filter((d) => d !== dayFormatted)
        : [...prev, dayFormatted]
    );
  };

  const removeDayOff = (dayToRemove) => {
    setDaysOff(daysOff.filter(day => day !== dayToRemove));
  };

  const nextMonth = () => setCurrentMonth(addDays(endOfMonth(currentMonth), 1));
  const prevMonth = () => setCurrentMonth(addDays(startOfMonth(currentMonth), -1));

  const handleSeasonChange = (event, newValue) => {
    setSeason(newValue);
  };

  const renderHeader = () => (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <IconButton onClick={prevMonth}><ArrowBackIosNewIcon fontSize="small" /></IconButton>
      <Typography variant="body2" fontWeight={600}>
        {format(currentMonth, "dd.MM.yyyy")}
    </Typography>
      <IconButton onClick={nextMonth}><ArrowForwardIosIcon fontSize="small" /></IconButton>
    </Box>
  );

  const renderTimeInputs = () => {
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box mt={4}>
          <Tabs value={season} onChange={handleSeasonChange} sx={{ mb: 3 }}>
            <Tab label="Sommerzeit" value="summer" />
            <Tab label="Winterzeit" value="winter" />
          </Tabs>
          
          <Grid container spacing={3}>
            <Grid item xs={5}>
              <TimePicker
                label="Öffnungszeit"
                value={timings[season].open}
                onChange={(newValue) => handleTimeChange(season, "open", newValue)}
                ampm={false} // Force 24-hour format
                minutesStep={5} // 5-minute intervals
                slotProps={{
                  textField: {
                    fullWidth: true,
                  },
                }}
              />
            </Grid>
            <Grid item xs={5}>
              <TimePicker
                label="Schließzeit"
                value={timings[season].close}
                onChange={(newValue) => handleTimeChange(season, "close", newValue)}
                ampm={false} // Force 24-hour format
                minutesStep={5} // 5-minute intervals
                slotProps={{
                  textField: {
                    fullWidth: true,
                  },
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </LocalizationProvider>
    );
  };

  const renderDaysOffList = () => {
    if (daysOff.length === 0) {
      return <Typography variant="body2" color="textSecondary">Keine freien Tage festgelegt</Typography>;
    }

    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2 }}>
        {daysOff.map(day => (
          <Chip
            key={day}
            label={format(parseISO(day), "dd.MM.yyyy")} 
            onDelete={() => removeDayOff(day)}
            sx={{ backgroundColor: '#f5f0e8' }}
          />
        ))}
      </Box>
    );
  };

  const renderCalendar = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
    const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });

    const days = [];
    let day = startDate;
    while (day <= endDate) {
      days.push(new Date(day));
      day = addDays(day, 1);
    }

    return (
      <Grid container spacing={1} justifyContent="flex-start">
        {days.map((dayItem) => {
          if (!isSameMonth(dayItem, monthStart)) return null;
          
          const formatted = format(dayItem, "d");
          const dayFormatted = format(dayItem, "yyyy-MM-dd");
          const isDayOff = daysOff.includes(dayFormatted);
          const isToday = isSameDay(dayItem, new Date());

          return (
            <Grid item key={dayItem.toString()}>
              <Box 
                sx={{
                  width: CELL_SIZE,
                  height: CELL_SIZE,
                  borderRadius: "50%",
                  bgcolor: isToday ? "#caa96a" : isDayOff ? "#f5f0e8" : "#ffffff",
                  border: isDayOff ? "2px solid #D6B981" : "1px solid #e0e0e0",
                  color: isDayOff ? "black" : "black",
                  fontWeight: isToday ? "bold" : "normal",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer"
                }} 
                onClick={() => toggleDayOff(dayItem)}
              >
                <Typography variant="body2">{formatted}</Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  if (loading || !settings) return <Typography>Loading...</Typography>;

  return (
    <Box mb={6}>
      {/* Timing Section */}
      <Box display="flex" sx={{ bgcolor: "#f7f7f7", borderRadius: "16px", mb: 4 }}>
        <Box sx={{ bgcolor: "#D6B981", width: 120, display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}>
          <Typography variant="h6"  color="black" sx={{ fontSize: "18px", fontFamily: "DM Sans", fontWeight: 600 }}>Die Tage</Typography>
        </Box>
        <Box flex={1} p={4}>
          <Typography variant="body1" color="black" fontWeight={500} mb={4} gutterBottom>Öffnungszeiten</Typography>
          
          {renderTimeInputs()}
          
          <Typography variant="body1" color="black" fontWeight={500} mt={4} gutterBottom>Freie Tage</Typography>
          {renderHeader()}
          {renderCalendar()}
          
          <Typography variant="body1"  color="black" fontWeight={500} mt={4} gutterBottom>
            Ausgewählte freie Tage:
          </Typography>
          {renderDaysOffList()}
        </Box>
      </Box>

      <form onSubmit={formik.handleSubmit}>
        <Box display="flex" sx={{ bgcolor: "#f7f7f7", borderRadius: "16px" }}>
          <Box sx={{ bgcolor: "#CD9D41", width: 134, display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "16px", borderBottomLeftRadius: "16px" }}>
            <Typography color="black"  variant="h6" sx={{ fontSize: "18px", fontFamily: "DM Sans", fontWeight: 600 }}>Notizen</Typography>
          </Box>
          <Box p={4} flex={1}>
            <Grid container spacing={5}>
              {[1, 2, 3].map((i) => (
                <Grid size={12} key={i}>
                  <FromikTextField
                    formik={formik}
                    name={`note${i}`}
                    label={`Notiz ${i}`}
                    placeholder={`Notiz ${i}`}
                    multiline
                    maxRows={4}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
        <Divider sx={{ color: "#00000038", my: 4 }} />
        {role === 'manager' && (
          <Box textAlign="right" sx={{ mt: 2, mb: 2, pr: 2 }}>
            <CustomButton
              onClick={() => formik.handleSubmit()}
              title="Einstellungen"
            />
          </Box>
        )}
      </form>
    </Box>
  );
};

export default Einstellungen;